import { LISTING_STATUS } from '../constants/listingStatus';
import { findListingEntity } from './entityReadHelpers';
import { upsertListing, upsertListingVariant } from './entityAdapter';
import { setActiveTabByProductChannel } from './uiAdapter';

const resolveListingDraftDomainsFromResult = (listing, variants) => {
  if (listing?.draftDomains) return listing.draftDomains;

  const drafted = (variants || []).filter(
    (variant) => variant.listingStatus === LISTING_STATUS.DRAFT && variant.draftDomains,
  );
  if (!drafted.length) return null;

  return {
    text: drafted.some((variant) => variant.draftDomains.text),
    media: drafted.some((variant) => variant.draftDomains.media),
  };
};

export const applyCreateDraftResult = (state, {
  productId,
  channelId,
  listing,
  variants = [],
}) => {
  if (!listing) return;

  const existingListing = findListingEntity(state, { masterProductId: productId, channelId });

  const hasDraftVariants = variants.some(
    (variant) => variant.listingStatus === LISTING_STATUS.DRAFT,
  );
  const listingStatus = listing.listingStatus === LISTING_STATUS.DRAFT || hasDraftVariants
    ? LISTING_STATUS.DRAFT
    : listing.listingStatus;
  const draftDomains = resolveListingDraftDomainsFromResult(listing, variants);

  setActiveTabByProductChannel(state, productId, channelId, listingStatus);

  upsertListing(state, {
    ...(existingListing || {}),
    ...listing,
    listingStatus,
    ...(draftDomains ? { draftDomains } : {}),
    masterProductId: productId,
  });

  variants.forEach((variant) => {
    upsertListingVariant(state, variant);
  });
};
